<template>
  <v-layout>
    <div class="page-banner banner-physical">
      <div class="page-banner-mask" />
      <div class="banner-inner">
        <h1><span class="icon-newspaper" />Physical Media</h1>
        <p>Your brand in their hand.</p>
      </div>
    </div>
    <el-container class="lower-shadow intro-section">
      <el-main class="site-inner">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            class="article-bottom-margin">
            <h2>The Original Form of Media</h2>
            <p>Ever grab a pen only to realize you accidently took it from the bank you where at? Happen to have a
            magnet on your fridge that has the contact information for the last plumber or electrician doing work for
            you? Keep a desk calendar for jotting notes while on the phone, maybe with a certain banks pen?</p>
            <p>In today’s digital age, the power of physical media can easily be overlooked. Leaving a pen with a
            customer can be a subtle way of passing out your contact information. At the same time, a poorly designed
            business card can seem to busy and turn customers away. Ingalls Image can help you design and print your
            items, making sure that you send the same strong and clear message across a vast array of products.</p>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <el-container class="sunken-container company-brand lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2>
              <span class="icon-wallet"/>Company Brand
            </h2>
          </div>
          <div class="sunken-body">
            <p>Your brand is your visual presence to all customers. This should be one of the cornerstones to your
            business and you should strive to make sure it is honored on any work you do or have done for you. To
            that end, Ingalls Image will work to either create a new one if that is desired, or will honor any
            existing one should your business provide it.</p>
            <service-section>
              <h3 slot="header">Our Web Site Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-drivers-license-o" />Identity
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Work with you to help you identify your brand and how it is being received by your customers. We
                    want to make sure the message you believe you are sending lines up with the message you are
                    sending.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-edit" />Design
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Looking to update an existing design, rebrand yourself or a product, or are you looking to have
                    a new brand created for a new product? No worries, we can help you with that!</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-compass" />Guidelines
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Now that you have your brand, how do you make sure it is always the same when multiple people
                    are using it to create marketing and promotional works; both internal and external.</p>
                  </span>
                </service-article>
              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <div class="shadow-bar lower-shadow" />

    <el-container class="sunken-container professional-image lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2>
              <span class="icon-picture"/>Professional Image
            </h2>
          </div>
          <div class="sunken-body">
            <p>Your business, your name, your image. All of these are important to you and the continued growth of your
            company. We understand this and work hard to make sure that even the smallest detail is looked after so
            you don't have to.</p>
            <service-section>
              <h3 slot="header">Our Email Campaign Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-printer" />Print Media
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Flyers, tri-folds, menus, and brochures just to name a few. We can design, layout, and print any
                    and all of your needs.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-business-card" />Business Cards
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Professionally designed and quality printed. Start off on the right foot with a great business
                    card they will remember and will give you a great first impression.</p>
                  </span>
                </service-article>

              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <div class="shadow-bar lower-shadow" />

    <el-container class="sunken-container trade-show lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2>
              <span class="icon-gift"/>Promotional
            </h2>
          </div>
          <div class="sunken-body">
            <p>Trade shows, handouts, and gifts. Opportunities to show off your business to gain new customers.
            Calendars and magnants are nice small items you can sell and leave with your customers that will show
            your business off to their guest and help garner new leads.</p>
            <service-section>
              <h3 slot="header">Our Email Campaign Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-presentation" />Trade Show
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Big events where you are but one of many. At these times you need to make sure your booth speaks
                    clearly to your professionalism and skill. You need every edge to stand out over your competition
                    and we can help plan, design, and print what you need.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-pen-tool" />Promotional Products
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Promotional products that are perfect for trade show goodie bags, giveaways, or merchandise your
                    customers can pick to help spread the word and have additional information about your business on
                    them.</p>
                  </span>
                </service-article>

              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </v-layout>
</template>

<script>
import ServiceSection from '@/layouts/sections/services.vue';
import ServiceArticle from '@/layouts/articles/service.vue';
import 'element-ui/lib/theme-chalk/display.css';

/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import VLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'PhysicalMedia',

  metaInfo: {
    title: 'Ingalls Image', // set a title
    titleTemplate: 'Physical Media | %s', // title is now "My Example App - Yay!"
    htmlAttrs: {
      lang: 'en',
      amp: undefined, // "amp" has no value
    },
    meta: [
      { itemprop: 'name', content: 'Physical Media | Ingalls Image' },
      { itemprop: 'description', content: 'Your prints, products, and promotional materials served up how you wnat them.' },
      { itemprop: 'image', content: 'https://www.ingallsimage.com/img/open-graph/physical-media.jpg' },
      { property: 'og:title', content: 'Physical Media | Ingalls Image' },
      { property: 'og:description', content: 'Your prints, products, and promotional materials served up how you wnat them.' },
      { name: 'description', property: 'description', content: 'Your prints, products, and promotional materials served up how you wnat them.' },
      { property: 'og:image', content: 'https://www.ingallsimage.com/img/open-graph/physical-media.jpg' },
      { property: 'og:url', content: 'https://www.ingallsimage.com/physical-media' },
    ],
    link: [
      { rel: 'canonical', href: 'https://www.ingallsimage.com/physical-media' },
    ],
  },
  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
    ServiceSection,
    ServiceArticle,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$ga.page(this.$router);
  },
  methods: {
    collapseToggle(e) {
      let parent = e.target.parentElement;
      if (parent.nodeName === 'H4') {
        parent = e.target.parentElement.parentElement;
      }
      const grandParent = parent.parentElement;
      const main = parent.nextSibling;
      if (main.style.maxHeight) {
        main.style.maxHeight = null;
        grandParent.classList.remove('collapse-active');
      } else {
        main.style.maxHeight = `${main.scrollHeight}px`;
        grandParent.classList.add('collapse-active');
      }
    },
  },
};
</script>
